exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dashboard[data-v-471af8ea]{margin-top:28px;min-height:calc(100vh - 53px);display:flex}", ""]);

// exports
